<template>
    <div class="layout">
        <div class="layout__header">
            <div class="layout__title">
                <h3>{{ $t('message.localizacion') }}</h3>
            </div>
        </div>
        <div class="card">
            <div class="card__content">
                <div class="row">
                    <div class="col-xs-12 col-md-6">
                        <div class="form-field">
                            <input-field :readonly="!editable" v-model="form.codigo" id="codigo" placeholder="##">
                                <span>{{ $t('message.codigo') }}</span>
                                <span v-if="errores.codigo" class="helper-text text-danger" slot="helper">
                                    <strong>{{ errores.codigo[0] }}</strong>
                                </span>
                            </input-field>
                        </div>
                    </div>
                    <div class="col-xs-12 col-md-6">
                        <div class="form-field select2">
                            <div class="select2-field">
                                <v-select @input="inputLinea" v-model="selectedLinea" id="linea" :options="lineas" label="nombre"></v-select>
                                <label for="linea">{{ $t('message.linea') }}</label>
                                <span v-if="errores.linea_id" class="helper-text text-danger" slot="helper">
                                    <strong>{{ errores.linea_id[0] }}</strong>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-12 col-md-6">
                        <div class="form-field">
                            <input-field v-model="form.descripcion" id="descripcion">
                                <span>{{ $t('message.descripcion') }}</span>
                                <span v-if="errores.descripcion" class="helper-text text-danger" slot="helper">
                                    <strong>{{ errores.descripcion[0] }}</strong>
                                </span>
                            </input-field>
                        </div>
                    </div>
                    <div v-show="false" class="col-xs-12 col-md-6">
                        <div class="form-field">
                            <div class="select-field">
                                <select :disabled="!editable" name="tipo" id="tipo" v-model="form.tipo">
                                    <option value="M">{{ $t('message.maquina') }}</option>
                                    <option value="C">{{ $t('message.caja') }}</option>
                                </select>
                                <label for="tipo">{{ $t('message.tipo') }}</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-buttons">
            <button @click="aceptar" class="btn-success" type="button"><i class="fa fa-save"></i><span>{{ $t('message.guardar') }}</span></button>
            <button @click="$emit('cancelar')" class="btn-danger btn--text" type="button"><i class="fa fa-ban"></i><span>{{ $t('message.cancelar') }}</span></button>
        </div>
    </div>
</template>

<script>
export default {
    props : {
        value : {
            type : Object,
            required : false, 
            default : function () {
                return {
                    id : '',
                    codigo : '',
                    descripcion : '',
                    estado : 'N',
                    tipo : 'M',
                    linea_id : ''                };
            }
        },
        lineas : {
            type : Array,
            required : false,
            default : function () {
                return [];
            }
        }
    },
    computed : {
        editable : function () {
            return this.form.estado === 'N';
        }
    },
    data : function () {
        return {
            form : this.value,
            errores : {},
            url : url,
            selectedLinea : null
        }
    },
    methods : {
        inputLinea : function () {
            if (this.selectedLinea !== null)
                this.form.linea_id = this.selectedLinea.code;
            else 
                this.form.linea_id = '';
        },
        aceptar : function () {
            let urlRequest = this.url + '/localizaciones';
            if (this.form.estado !== 'N')
            {
                urlRequest += '/' + this.form.id;
                this.form._method = 'PUT';
            }
            else 
                this.form._method = undefined;
            let that = this;
            axios.post(urlRequest, this.form).then(function (response) {
                swal(that.$t('message.saved'), that.$t('message.aviso'), 'success');
                that.$emit('saved', response.data);
            }).catch(function (error) {
                if (error !== undefined && error !== null) {
                    let response = error.response;
                    if (response !== undefined && response !== null) {
                        let status = response.status;
                        if (status === 422) {
                            that.errores = response.data.errors;
                            swal(that.$t('message.errorValidacion'), that.$t('message.aviso'), 'warning');
                        }
                        else 
                            swal(that.$t('message.errorText'), that.$t('message.error'), 'error');
                    }
                }
            })
        }
    },
    mounted : function () {
        for (let i = 0; i < this.lineas.length; i++)
            if (this.lineas[i].code === this.form.linea_id) {
                this.selectedLinea = this.lineas[i];
                break;
            }
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/localizaciones/Localizacion.vue